import React from 'react';
import { motion } from 'framer-motion';
import { Star, User, CheckCircle2 } from 'lucide-react';
const reviews = [{
  name: 'Marek W.',
  role: 'Trener U10 — Warszawa',
  quote: 'W końcu coś co działa w praktyce. Już w pierwszym tygodniu znalazłem 3 błędy w swojej metodyce których wcześniej nie widziałem.',
  color: 'bg-blue-500'
}, {
  name: 'Tomasz K.',
  role: 'Trener U8 — Kraków',
  quote: 'Skróciłem czas przygotowania o 80% w pierwszym miesiącu. Nie wierzyłem że PDF może tyle zmienić.',
  color: 'bg-green-500'
}, {
  name: 'Rafał B.',
  role: 'Trener U12 — Poznań',
  quote: 'W końcu uwolniłem się od wymyślania planu na nowo każdego tygodnia. Ten system naprawdę działa.',
  color: 'bg-purple-500'
}];
export function TopReviews() {
  return <section className="w-full bg-navy-primary py-12 md:py-20 px-4 md:px-6" data-id="element-307">
      <div className="max-w-6xl mx-auto" data-id="element-308">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-center text-white mb-8 md:mb-12" data-id="element-309">
          Ponad 1 200 trenerów nam zaufało
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-4 md:gap-8" data-id="element-310">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white rounded-2xl p-5 md:p-6 shadow-lg flex flex-col h-full border-l-4" style={{
          borderLeftColor: '#1A7C3E'
        }} data-id="element-311">
              {/* 5 gold stars at top */}
              <div className="flex gap-1 mb-3" data-id="element-312">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5" style={{
              fill: '#F5A623',
              color: '#F5A623'
            }} data-id="element-313" />)}
              </div>

              {/* Verified badge */}
              <div className="inline-flex items-center gap-1.5 self-start px-2.5 py-1 rounded-full text-xs font-semibold mb-4" style={{
            background: 'rgba(26, 124, 62, 0.12)',
            color: '#1A7C3E'
          }} data-id="element-314">
                <CheckCircle2 className="w-3.5 h-3.5" data-id="element-315" />
                Zweryfikowany zakup
              </div>

              <div className="flex items-start gap-3 md:gap-4 mb-4" data-id="element-316">
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full ${review.color} flex items-center justify-center flex-shrink-0`} data-id="element-317">
                  <User className="w-5 h-5 md:w-6 md:h-6 text-white" data-id="element-318" />
                </div>
                <div data-id="element-319">
                  <h3 className="font-bold text-navy-primary text-sm md:text-base" data-id="element-320">
                    {review.name}
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600" data-id="element-321">
                    {review.role}
                  </p>
                </div>
              </div>

              <p className="text-sm md:text-base text-gray-700 leading-relaxed flex-grow" data-id="element-322">
                "{review.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}